import { lazy } from "react";
import Loadable from "app/components/Loadable";

const SubGroupList = Loadable(lazy(() => import("./SubGroupList")));
const SubGroupAdd = Loadable(lazy(() => import("./SubGroupAdd")));

const SubGroupRoutes = [
  { path: "/asset/sub-groups", element: <SubGroupList /> },
  { path: "/asset/sub-groups/:mode/:id", element: <SubGroupAdd /> },
];

export default SubGroupRoutes;
